import React from 'react';
import { Table, TableBody } from 'semantic-ui-react';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectFertilizerWorksheetProducts } from './selectors';
import FertilizerPrintWorksheetProductsTableRow from './components/FertilizerPrintWorksheetProductsTableRow';
import FertilizerPrintWorksheetProductsTableRowHeader from './components/FertilizerPrintWorksheetProductsTableRowHeader';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetProductsTable(
    props: Props
): React.ReactElement {
    const { pageIndex } = props;

    const products = useSelector((state: AppState) =>
        makeSelectFertilizerWorksheetProducts()(state, props)
    );

    return (
        <ResponsiveTable>
            <Table basic="very" className="basic-table" unstackable>
                <FertilizerPrintWorksheetProductsTableRowHeader />
                <TableBody>
                    {products &&
                        products.map(({ id, perUnitType }) => (
                            <FertilizerPrintWorksheetProductsTableRow
                                productId={id}
                                pageIndex={pageIndex}
                                key={id}
                                perUnitType={perUnitType}
                            />
                        ))}
                </TableBody>
            </Table>
        </ResponsiveTable>
    );
}
